/**************************************************
 * Nombre:       Formulario_Indicadores
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {SpaceBar,Numbers,Title} from "@mui/icons-material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";

const Formulario_Indicadores = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={12} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={Title} nombre={'Titulo'} {...props} dato={'nombre'}/>
                </Grid>

                <Grid container size={12} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={Numbers} nombre={'Dato'} {...props} dato={'numero'}/>
                </Grid>

                <Grid container size={12} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={SpaceBar} nombre={'Complemento'} {...props} dato={'descripcion'}/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Indicadores